import { getRequestv1 } from './api.service'

export async function getProductById(id, cancelPendingRequest) {
  const endpoint = `/v1/products/${id}`
  try {
    const response = await getRequestv1(endpoint, cancelPendingRequest)
    return response.data
  } catch (e) {
    throw new Error('Could not fetch product')
  }
}
